import React from 'react';
import { plusIcon } from '@chordbaker/design';

interface PlusIconProps {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

const PlusIcon: React.FC<PlusIconProps> = ({
  size = 16,
  color = 'currentColor',
  style
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={plusIcon.viewBox}
      fill={plusIcon.fill}
      stroke={color}
      strokeWidth={plusIcon.strokeWidth}
      strokeLinecap={plusIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
      strokeLinejoin={plusIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
      style={style}
    >
      <path d={(plusIcon.elements[0] as { d: string }).d} />
    </svg>
  );
};

export default PlusIcon;
